<template>
  <section
    id="intro"
    class="text-center mb-12"
  >
    <v-img
      src="../../../assets/logo.svg"
      contain
      class="d-none d-md-block shrink mx-6"
      height="calc(3em * 5)"
    />
    <h1
      class="lushary--text font-weight-light px-1 my-8"
      :class="$vuetify.breakpoint.mdAndUp ? 'display-1' : 'title'"
    >
      More emotions, more photos
    </h1>

    <v-responsive
      class="mx-auto mt-2 px-4 subtitle-1 grey--text"
      max-width="650"
    >
      Cоздание фотографии — особый вид искусства, в котором человек является источником вдохновения. Это мой личный способ познать мир и раскрыть вашу истинную сущность.
    </v-responsive>
  </section>
</template>

<script>
  export default {
    name: 'Headline',
  }
</script>
